module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '¥',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '¥',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '¥',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '¥',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '¥',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7415322345633',
        variantId: ['42082797813921', '42082797846689', '42082797879457'],
        capacity: 2,
        productName: 'EcoFlow パワーシステム(2kWh)',
        name: 'スターターキット (2kWh)',
        discountPrice: 572000,
        originalPrice: 572000,
        unit: '¥',
        includes: ['EcoFlow パワーシステム専用2kWh LFPバッテリー x1', 'EcoFlow パワーハブ', 'EcoFlow パワーハブ専用ケーブルセット'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7415322411169',
        variantId: ['42082798108833', '42082798141601', '42082798174369'],
        capacity: 4,
        productName: 'EcoFlow パワーシステム(4kWh)',
        name: 'スターターキット (4kWh)',
        discountPrice: 792000,
        originalPrice: 792000,
        unit: '¥',
        includes: ['EcoFlow パワーシステム専用2kWh LFPバッテリー x2', 'EcoFlow パワーハブ', 'EcoFlow パワーハブ専用ケーブルセット'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7415322673313',
        variantId: ['42082801680545', '42082801713313', '42082801746081'],
        capacity: 5,
        productName: '5kWhパワーシステム',
        name: 'スターターキット (5kWh)',
        discountPrice: 858000,
        originalPrice: 858000,
        unit: '¥',
        includes: ['EcoFlow パワーシステム専用5kWh LFPバッテリー x1', 'EcoFlow パワーハブ', 'EcoFlow パワーハブ専用ケーブルセット'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7415321526433',
        variantId: ['42082785099937', '42082785165473', '42082785198241'],
        capacity: 10,
        productName: 'EcoFlow パワーシステム(10kWh) ',
        name: 'スターターキット (10kWh)',
        discountPrice: 1375000,
        originalPrice: 1375000,
        unit: '¥',
        includes: ['EcoFlow パワーシステム専用5kWh LFPバッテリー x2', 'EcoFlow パワーハブ', 'EcoFlow パワーハブ専用ケーブルセット'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7415322312865',
        variantId: ['42082797289633', '42082797322401', '42082797355169'],
        capacity: 15,
        productName: 'EcoFlow パワーシステム(15kWh) ',
        name: 'スターターキット (15kWh)',
        discountPrice: 1903000,
        originalPrice: 1903000,
        unit: '¥',
        includes: ['EcoFlow パワーシステム専用5kWh LFPバッテリー x3', 'EcoFlow パワーハブ', 'EcoFlow パワーハブ専用ケーブルセット'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: '使用電力の制御と可視化で\nシステム管理が便利に',
      discountPrice: 300,
      originalPrice: 538,
      unit: '¥',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'EcoFlow パワーシステム専用スマート分電盤',
        desc: 'ヒューズ付きのDC回路が12個、AFCI付きのAC回路が6個あり、キャンピングカーやオフグリッド住宅の配電を管理することができます。EcoFlowアプリまたはタッチパネルモニターで最大6回路のDCを制御します。',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'EcoFlow パワーシステム専用スマート分電盤',
          desc: 'ヒューズ付きのDC回路が12個、AFCI付きのAC回路が6個あり、キャンピングカーやオフグリッド住宅の配電を管理することができます。EcoFlowアプリまたはタッチパネルモニターで最大6回路のDCを制御します。',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC入力',
            value: '最大30A, 100V, 3,000W'
          }, {
            key: 'DC入力',
            value: '最大70A'
          }, {
            key: 'AC出力',
            value: 'AC出力ポートx6、各ポート最大20A'
          }, {
            key: 'DC出力',
            value: 'DC出力ポートx12 (12のうち6のみタッチパネルモニターとアプリでの制御に対応）'
          }, {
            key: '動作温度範囲',
            value: '-25℃～60℃'
          }, {
            key: '寸法',
            value: '210×354×98mm（高さ×幅×奥行）'
          }, {
            key: '正味重量',
            value: '約2.6kg'
          }, {
            key: 'IP保護等級',
            value: 'IP21'
          }, {
            key: '安全規格',
            value: 'UL Standard, FCC,PSE'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'バッテリー固定用バンド',
        desc: 'バッテリーを安全かつ確実に取り付けるためのアクセサリーです。',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: 'システム制御や電力使用量の\n監視を強化したい方に',
      discountPrice: 1600,
      originalPrice: 2355,
      unit: '¥',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'EcoFlow パワーシステム専用スマート分電盤',
        desc: 'ヒューズ付きのDC回路が12個、AFCI付きのAC回路が6個あり、キャンピングカーやオフグリッド住宅の配電を管理することができます。EcoFlowアプリまたはタッチパネルモニターで最大6回路のDCを制御します。',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'EcoFlow パワーシステム専用スマート分電盤',
          desc: 'ヒューズ付きのDC回路が12個、AFCI付きのAC回路が6個あり、キャンピングカーやオフグリッド住宅の配電を管理することができます。EcoFlowアプリまたはタッチパネルモニターで最大6回路のDCを制御します。',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC入力',
            value: '最大30A, 100V, 3,000W'
          }, {
            key: 'DC入力',
            value: '最大70A'
          }, {
            key: 'AC出力',
            value: 'AC出力ポートx6、各ポート最大20A'
          }, {
            key: 'DC出力',
            value: 'DC出力ポートx12 (12のうち6のみタッチパネルモニターとアプリでの制御に対応）'
          }, {
            key: '動作温度範囲',
            value: '-25℃～60℃'
          }, {
            key: '寸法',
            value: '210×354×98mm（高さ×幅×奥行）'
          }, {
            key: '正味重量',
            value: '約2.6kg'
          }, {
            key: 'IP保護等級',
            value: 'IP21'
          }, {
            key: '安全規格',
            value: 'UL Standard, FCC,PSE'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'EcoFlow パワーシステム専用タッチパネルモニター',
        desc: '消費電力を制御、およびモニタリングします。',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'EcoFlow パワーシステム専用タッチパネルモニター',
          desc: '消費電力を制御、およびモニタリングします。',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'ディスプレイ(対角寸法)',
            value: '7インチ(154.21x85.92mm)(幅×高さ)'
          }, {
            key: '電源電圧',
            value: '12 VDC'
          }, {
            key: '動作温度範囲',
            value: '-25℃～60℃'
          }, {
            key: '寸法',
            value: '113.3×204.5×22.35mm（高さ×幅×奥行）'
          }, {
            key: '正味重量',
            value: '約0.45kgs'
          }, {
            key: '安全規格',
            value: 'UL Standard, FCC,ICES,CE,UKCA,E-Mark,RCM,TELEC,KCC'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_4',
        name: 'バッテリー固定用バンド',
        desc: 'バッテリーを安全かつ確実に取り付けるためのアクセサリーです。',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7415329685665',
      variantId: '42082928623777',
      name: 'EcoFlow 100W据置型ソーラーパネル(剛性)*2 + 据置型ソーラーパネル(剛性)固定用マウント*2',
      discountPrice: 34100,
      originalPrice: 34100,
      // discountRate: 0.8,
      unit: '¥',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: 'EcoFlow 100W据置型ソーラーパネル(剛性)*2 + 据置型ソーラーパネル(剛性)固定用マウント*2',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: '定格電力',
          value: '100W (+/-5W)'
        }, {
          key: '開回路電圧',
          value: '20.3V'
        }, {
          key: '短絡電流',
          value: '6.3 A'
        }, {
          key: '最大動作電圧',
          value: '17.1 V'
        }, {
          key: '最大動作電流',
          value: '5.9 A'
        }, {
          key: '定格電力の温度係数',
          value: '-0.39 % /℃'
        }, {
          key: '開回路電圧の温度係数',
          value: '-0.33 % /℃'
        }, {
          key: '短絡電流の温度係数',
          value: '0.06 % /℃'
        }, {
          key: '最大システム電圧',
          value: '600 VDC(UL)'
        }, {
          key: '最大ヒューズ電流',
          value: '15A'
        }, {
          key: '正味重量',
          value: '約6.2kg'
        }, {
          key: '寸法',
          value: '980×586×30mm'
        }]
      },
      question: {}
    }, {
      productId: '7415330046113',
      variantId: '42082933276833',
      name: 'EcoFlow 400W据置型ソーラーパネル(剛性)*2 + 据置型ソーラーパネル(剛性)固定用マウント*4',
      discountPrice: 140800,
      originalPrice: 140800,
      // discountRate: 0.8,
      unit: '¥',
      number: 0,
      capacity: 800,
      freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: 'EcoFlow 400W据置型ソーラーパネル(剛性)*2 + 据置型ソーラーパネル(剛性)固定用マウント*4',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: '定格電力',
          value: '400W (+/-3 W)'
        }, {
          key: '開回路電圧',
          value: '37.10V'
        }, {
          key: '短絡電流',
          value: '13.79A'
        }, {
          key: '最大動作電圧',
          value: '31.00V'
        }, {
          key: '最大動作電流',
          value: '12.90A'
        }, {
          key: '定格電力の温度係数',
          value: '-0.38 % /℃'
        }, {
          key: '開回路電圧の温度係数',
          value: '-0.35 % /℃'
        }, {
          key: '短絡電流の温度係数',
          value: '+0.06 % /℃'
        }, {
          key: '最大システム電圧',
          value: '1500V DC'
        }, {
          key: '最大ヒューズ電流',
          value: '25A'
        }, {
          key: '動作温度範囲',
          value: '-20℃ - +50℃'
        }, {
          key: '正味重量',
          value: '約21.8Kg'
        }, {
          key: '寸法',
          value: '1722×1134×35mm'
        }]
      },
      question: {}
    }, {
      productId: '7415550673057',
      variantId: '42084267425953',
      name: 'EcoFlow 100W据置型ソーラーパネル(柔性)',
      discountPrice: 17490,
      originalPrice: 17490,
      // discountRate: 0.8,
      unit: '¥',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: 'EcoFlow 100W据置型ソーラーパネル(柔性)',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: '定格電力',
          value: '100 W (+/- 5 W)'
        }, {
          key: '開回路電圧',
          value: '20.3 V'
        }, {
          key: '短絡電流',
          value: '6.3 A'
        }, {
          key: '最大動作電圧',
          value: '17.1 V'
        }, {
          key: '最大動作電流',
          value: '5.9 A'
        }, {
          key: '定格電力の温度係数',
          value: '-0.39%/℃'
        }, {
          key: '開回路電圧の温度係数',
          value: '-0.33%/℃'
        }, {
          key: '短絡電流の温度係数',
          value: '0.06%/℃'
        }, {
          key: '最大システム電圧',
          value: '600 VDC (UL)'
        }, {
          key: '最大ヒューズ電流',
          value: '15 A'
        }, {
          key: '正味重量',
          value: '約2.3 kg'
        }, {
          key: '寸法',
          value: '1, 055 * 612 * 25 mm'
        }]
      },
      question: {}
    }, {
      productId: '7148022431905',
      variantId: '41282474836129',
      name: 'EcoFlow 400Wソーラーパネル',
      discountPrice: 126500,
      originalPrice: 126500,
      // discountRate: 0.8,
      unit: '¥',
      number: 0,
      capacity: 400,
      locale: ['us', 'ca', 'au', 'jp'],
      // only for us site
      img: '/img/calculators/mm100/solar-400-portable.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: 'EcoFlow 400Wソーラーパネル',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
        specParams: [{
          key: '定格電力',
          value: '400W(+/-10W)*'
        }, {
          key: '開回路電圧',
          value: '48V(Vmp 41V)'
        }, {
          key: '短絡電流',
          value: '11A(Imp 9.8A)'
        }, {
          key: '発電効率',
          value: '約22.4 %'
        }, {
          key: 'セルの種類',
          value: '単結晶セル'
        }, {
          key: '出力コネクター仕様',
          value: 'MC4'
        }, {
          key: '正味重量',
          value: '約16kg'
        }, {
          key: '寸法（広げた状態）',
          value: '4106.8x239.0x2.4cm'
        }, {
          key: '寸法（畳んだ状態）',
          value: '106.8x62.0x2.4cm'
        }]
      },
      question: {}
    }],
    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      42082797813921: 'power-2kw.jpg',
      42082797846689: 'bundle-2kw-dp.jpg',
      42082797879457: 'bundle-2kw-all_us.jpg',
      42082798108833: 'power-4kw.jpg',
      42082798141601: 'bundle-4kw-dp.jpg',
      42082798174369: 'bundle-4kw-all_us.jpg',
      42082801680545: 'power-5kw.jpg',
      42082801713313: 'bundle-5kw-dp.jpg',
      42082801746081: 'bundle-5kw-all_us.jpg',
      42082785099937: 'power-10kw.jpg',
      42082785165473: 'bundle-10kw-dp.jpg',
      42082785198241: 'bundle-10kw-all_us.jpg',
      42082797289633: 'power-15kw.jpg',
      42082797322401: 'bundle-15kw-dp.jpg',
      42082797355169: 'bundle-15kw-all_us.jpg'
    },
    // combo's original price under the bundle
    comboPrice: {
      // productId
      7415322345633: {
        original: [0, 66000, 121000],
        discount: [0, 66000, 121000]
      },
      7415322411169: {
        original: [0, 88000, 132000],
        discount: [0, 88000, 132000]
      },
      7415322673313: {
        original: [0, 77000, 121000],
        discount: [0, 77000, 121000]
      },
      7415321526433: {
        original: [0, 75000, 132000],
        discount: [0, 75000, 132000]
      },
      7415322312865: {
        original: [0, 77000, 132000],
        discount: [0, 77000, 132000]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'EcoFlow パワーハブ',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: 'パワーハブはパワーシステムの核となるアイテムで、MPPTソーラー充電器2台、DC-DCバッテリー充電器(兼 MPPTソーラー充電器)、インバーター、DC-DC降圧コンバーター各1台の機能が集約されています。オールインワンの構成なので、余分なスペースをとらず、セットアップも非常に簡単です。',
      specParams: [{
        key: '正味重量',
        value: '約14kg'
      }, {
        key: '寸法',
        value: '30×48×14cm（高さ×幅×奥行）'
      }, {
        key: '安全規格',
        value: 'TELEC'
      }, {
        key: 'WI-FI',
        value: '対応'
      }, {
        key: 'Bluetooth',
        value: '対応'
      }, {
        key: 'AC出力/周波数',
        value: '純正弦波, 3,000W (サージ 6,000W), 100V, 50Hz/60Hz'
      }, {
        key: 'DC出力',
        value: '13.6V/70A 最大1,000W ; 26.4V/60A, 最大1,600W'
      }, {
        key: 'AC入力',
        value: 'X-Stream急速充電で最大3,000W, 最大30A'
      }, {
        key: 'AC入力電圧/周波数',
        value: '100-1200V, 50Hz/60Hz'
      }, {
        key: 'ソーラー充電入力',
        value: '15-150V 30A, 最大1,600W'
      }, {
        key: 'オルタネーター充電入力',
        value: '13-60V, 60A, 最大1,000W'
      }, {
        key: '推奨動作温度',
        value: '20℃～30℃'
      }, {
        key: '放電温度',
        value: '-25℃～60℃'
      }, {
        key: '充電温度',
        value: '-25℃～60℃'
      }, {
        key: '保存温度',
        value: '-25℃～60℃'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: '表示されている増加時間は、ソーラーパネル入力80％、日照時間5時間の平均値で算出した参考値です。実際の使用時間は、環境や日照条件等により異なります。'
    },
    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: false,
    wire: {
      name: 'カーブルパック + 取り付けストラップ'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};